import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Container = styled.div`
    background:#fff;
    padding: 20px var(--padding) 10px var(--padding);
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    position: fixed;
    top:0;
    left:0;
    width:100%;
    
    z-index: 100;

/*     
    > div{
        max-width: 480px;
        margin:0 auto;
    } */
    
    ${mq(Devices.laptop)} {
        
    }
`;

export const ChildDDL = styled.div`
    position: relative;
    z-index: 100;

`;

export const Selected = styled.div<{open:boolean, selected?:boolean}>`
    display:flex;
    align-items: center;
    gap:12px;
    border: 1px solid #2a848e7b;
    border-radius: 8px;
    padding:8px 12px;
    background:${props => props.selected?"#2a848e13":"#fff"};
    

    svg{
        width:16px;
        position: absolute;
        top:50%;
        transform: translateY(-50%) ${props => props.open?"rotateX(180deg)":""}; 
        right:16px;
    }
`;

export const ImageContainer = styled.div`
    position: relative;
    height:44px;
    width:44px;
    border-radius: 40px;
    overflow: hidden;

    > div{
        border-radius: 40px;
        overflow: hidden;
    }
`;

export const ChildInfo = styled.div`
    display:flex;
    flex-direction: column;
    gap:4px;
    span:nth-of-type(1){
        font-size: 16px;
        line-height: 18px;
    }
    span:nth-of-type(2){
        font-size: 16px;
        font-weight: 600;
        line-height: 18px;
        color:#2A848E;
    }
`;

export const DropList = styled.div<{open:boolean}>`
    display: ${props => props.open?"flex":"none"};
    position: absolute;
    top:110%;
    left:0;
    width:100%;
    background:#fff;
    box-shadow: 0 0px 4px rgba(0,0,0,0.25);
    padding:12px;
    border-radius: 10px;
    flex-direction: column;
    gap:12px;
    
`;

export const DropItem = styled.div<{selected?:boolean}>`
    display:flex;
    align-items: center;
    gap:12px;
    border: 1px solid #2a848e7b;
    border-radius: 8px;
    padding:8px 12px;
    background:${props => props.selected?"#2a848e13":"#fff"};
`;

export const ButtonList = styled.div`
    display:flex;
    gap:8px;
    margin-top: 16px;

    button{
        padding:6px 10px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        box-shadow: 0 0px 2px rgba(0,0,0,0.35);

        :nth-of-type(1){
            background:#2A848E;
            color:#fff;
        }
        :nth-of-type(2){
        }
    }
`;

export const SelectDDL = styled.div`
    position: relative;
    z-index: 100;

    .flexy{
        display:flex;
        align-items: center;
        gap:10px;
    }
`;

export const Check = styled.div<{checked:boolean}>`
    width:20px;
    height:20px;
    border-radius: 4px;
    border:1px solid ${props => props.checked?"#2A848E":"#3d3d3d"};
    display:flex;
    align-items: center;
    justify-content: center;

    > svg{
        display: ${props => props.checked?"block":"none"};
        width:70%;
    }
`;

export const DDLSelected = styled.div<{open:boolean, disable?:boolean}>`
    display:flex;
    align-items: center;
    gap:12px;
    border: 1px solid #2a848e7b;
    border-radius: 8px;
    padding:8px 12px;
    background:#fff;
    cursor: ${props => props.disable?"default":"pointer"};
    opacity: ${props => props.disable?0.6:1};

    svg{
        width:16px;
        position: absolute;
        top:50%;
        transform: translateY(-50%) ${props => props.open?"rotateX(180deg)":""}; 
        right:16px;
        opacity: ${props => props.disable?0.6:1};
    }
`;

// export const DropItem = styled.div<{selected?:boolean}>`
//     display:flex;
//     align-items: center;
//     gap:12px;
//     border: 1px solid #2a848e7b;
//     border-radius: 8px;
//     padding:8px 12px;
//     background:${props => props.selected?"#2a848e13":"#fff"};
// `;